export default "/_next/static/31e19f68a2de6f5ac664a272d02d3bc1.png";